<div class="container"
     [ngClass]="size">
    <div class="spinner-container">
        <mat-spinner [diameter]="diameter"
                     color="#0059f9"
                     mode="indeterminate"
                     value="50"></mat-spinner>
    </div>
</div>
